import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductListFilterState } from "@tSurya/Store/Data/SurProductListHideAndShowFilterState";
import { Draft } from "immer";

export interface CheckoutReviewSubmitState {
    isReviewSubmitPage: boolean;
}
const initialState: CheckoutReviewSubmitState = {
    isReviewSubmitPage: false,
};

const reducer = {
    "Custom/CheckoutReviewPage/SetisReviewSubmitPage": (
        draft: Draft<CheckoutReviewSubmitState>,
        action: { result: boolean },
    ) => {
        draft.isReviewSubmitPage = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
